const translations: { [key: string]: { [key: string]: string } } = {
  accountverification: {
    APP_TITLE: 'Sistema di auto-verifica',
    IDENTITY_TITLE: 'Verifica la tua identità',
    APP_DESCRIPTION_LINE_1:
      'Siamo tenuti a far in modo che il tuo account sia pienamente conforme ai requisiti normativi',
    APP_DESCRIPTION_LINE_2_BOLD: 'per età e verifica',
    APP_DESCRIPTION_LINE_2: ' e per questo avremo bisogno dei seguenti documenti da parte tua',
    DOCUMENT_UPLOAD_MESSAGE: 'Per favore carica almeno uno dei seguenti documenti',
    SCENARIO_NUMBER_TITLE: 'Passo',
    CHAT_LINK_TITLE_LINE_1: 'Se hai bisogno di assistenza',
    CHAT_LINK_TITLE_LINE_2: 'Contattaci via chat',
    VERIFICATION_REQUIRED_BTN_VALUE: 'Inizia ora',
    DOCUMENT_STATUS_VERIFIED: 'VERIFICATO',
    DOCUMENT_STATUS_REJECTED: 'RIFIUTATO',
    DOCUMENT_STATUS_PENDING: 'NON CARICATO',
    DOCUMENT_STATUS_REQUIRED: 'RICHIESTO',
    DOCUMENT_STATUS_SUBMITTED: 'INVIA',
    DOCUMENT_STATUS_NOT_UPLOADED: 'NON CARICATO',
    JOURNEY_COMPLETED_TITLE: 'Ben fatto!',
    VERIFICATION_COMPLETED: 'Il processo di verifica é stato completato. Il tuo account é attivo.',
    VERIFICATION_COMPLETED_BUTTON_LABEL: 'Accedi e divertiti',
    VERIFICATION_COMPLETED_BUTTON_VALUE: 'Accedi',
    SUBMIT_CONFIRMATION:
      "Abbiamo tutto quello che ci serve per ora e non ci vorrà molto per controllare il tutto e confermare l'esito.",
    SUBMIT_CONFIRMATION_TERM: 'Solitamente il processo di conferma prende fino a 24h.',
    SUBMIT_CONFIRMATION_FINISHED: 'Ti faremo sapere se ci sono problemi',
    SELECT_DOCUMENT_TYPE_TITLE: 'Seleziona il tipo di documento',
    SELECT_DOCUMENT_BACK_BTN: 'Indietro',
    PASSPORT: 'Passaporto',
    DRIVING_LICENSE: 'Patente',
    IDENTIFY_CARD: 'Carta di identità',
    ERROR_TITLE: 'Qualcosa é andato storto…,',
    ERROR_MESSAGE: 'Siamo dispiaciuti. Per favore prova di nuovo.',
    ERROR_BUTTON_VALUE: 'Volver a intentar',
    ERROR_TITLE_TOKEN_EXPIRED: 'Questo link é scaduto',
    ERROR_MESSAGE_TOKEN_EXPIRED:
      'Abbiamo mandato una email da verification@willhill.com. Per favore segui le istruzioni per completare la verifica.',
  },
};

export default translations;
